import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Wrench } from 'lucide-react';
import api from '../services/api';
import { Card, Label, Input, Button } from '../components/ui';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !senha) return toast.error('Preencha email e senha!');
    
    setLoading(true);
    const toastId = toast.loading('Autenticando...');
    try {
      const res = await api.post('/auth/login', { email, senha });
      toast.success('Bem-vindo de volta!', { id: toastId });
      onLogin(res.data.user, res.data.token);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Credenciais inválidas.', { id: toastId });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 bg-white shadow-2xl animate-in zoom-in-95 duration-300">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-brand/10 text-brand rounded-2xl flex items-center justify-center mb-4">
            <Wrench size={32} />
          </div>
          <h2 className="text-2xl font-bold text-slate-900">UP2 - OS</h2>
          <p className="text-slate-500 text-sm">Acesse o gestor de ordens de serviço</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label>E-mail de Acesso</Label>
            <Input type="email" placeholder="admin@up2.com" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div>
            <Label>Senha</Label>
            <Input type="password" placeholder="••••••" value={senha} onChange={e => setSenha(e.target.value)} />
          </div>
          <Button type="submit" className="w-full bg-brand hover:bg-orange-600 text-white text-lg h-12" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar no Sistema'}
          </Button>
        </form>
      </Card>
    </div>
  );
}